import { render, staticRenderFns } from "./Menubar.vue?vue&type=template&id=42a4f8c8&scoped=true"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a4f8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a4f8c8')) {
      api.createRecord('42a4f8c8', component.options)
    } else {
      api.reload('42a4f8c8', component.options)
    }
    module.hot.accept("./Menubar.vue?vue&type=template&id=42a4f8c8&scoped=true", function () {
      api.rerender('42a4f8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/dashboard/components/Menubar.vue"
export default component.exports